import React, { Component } from "react";
import { Container } from 'reactstrap';
import getConfig from 'next/config';
import Slider from "react-slick";

const config = getConfig().publicRuntimeConfig;

const settingsSliderDesktop = {
    arrows: false,
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 6,
    slidesToScroll: 1,
    autoplay: true
};
const settingsSliderMobile = {
    arrows: false,
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 2,
    slidesToScroll: 1,
    autoplay: true
};
export default class PatnersHomepage extends Component {

    constructor(props) {
        super(props);
    }


    partnersTrack = () => {
        if (window.eventDispatcher) {
            window.eventDispatcher.dispatchEvent('wedding-wishlist', eventInfo, { amplitude: true });
        }
    }

    render() {
        const { items } = this.props;

        const imagePanel = items.map((item, pa) => (
            <div xs="12" sm="12" md="2" lg="4"
                onClick = {() => item.redirectUrl ? this.partnersTrack : null}
                className=" d-flex justify-content-center align-self-center" key={pa} >
                {item.redirectUrl ? 
                    <a href={item.redirectUrl} target="_blank">
                        <img
                        className="patner-image  justify-content-center align-self-center"
                        src={`${config.cdnUrl}${item.imageUrl}`}
                        loading='lazy'
                        alt="stack images" />
                    </a> :
                    <img
                    className="patner-image justify-content-center align-self-center"
                    src={`${config.cdnUrl}${item.imageUrl}`}
                    loading='lazy'
                    alt="stack images" />
                }
                
            </div>
        ));

        return (
            <Container fluid >
                <div>
                    <p className="text-center patner-heading">Our Partners</p>
                    <div className="hide-for-mobile partner-list">
                        <Slider {...settingsSliderDesktop} >
                            {imagePanel}
                        </Slider>
                    </div>
                    <div className="hide-for-desktop partner-list">
                        <Slider {...settingsSliderMobile} >
                            {imagePanel}
                        </Slider>
                    </div>
                </div>
                <style global jsx>
                    {`
                       .patner-image {
                        width: 150px;
                        // margin: 0 30px 30px 0;
                    }  
                    .patner-heading{
                        padding-bottom: 1.5rem;
                        font-size: 34px;
                        // color: white;
                    }   
                    .partner-list{
                        margin-bottom: 2rem;
                    }
                    `}
                </style>
            </Container>
        );
    }
}